import { clientOutgoMappingKeys } from './mappings';

export default rawData =>
    Object.fromEntries(
        Object.keys(clientOutgoMappingKeys).map(key => [
            [clientOutgoMappingKeys[key]],
            rawData[key],
        ])
    );
